import { useEffect, useRef } from "react";
import useSound from "use-sound";
import { useGameSettings } from "./hook";

function getVolume(volume) {
  return volume / 100;
}

function Music({ url, volume = 1, play, loop }) {
  const { volume: currentVolume = 50, music } = useGameSettings();
  const [playSound, { stop, sound, isPlaying }] = useSound(url, {
    volume: getVolume(currentVolume),
  });
  const currentSound = useRef();

  useEffect(() => {
    if (currentSound.current && sound !== currentSound.current) {
      currentSound.current.stop();
    }

    if (play && music) {
      playSound();
      currentSound.current = sound;
    }
  }, [url]);

  useEffect(() => {
    if (play && music) {
      if (isPlaying) {
        return;
      }
      playSound();
      currentSound.current = sound;
    } else {
      stop();
    }
  }, [play, music]);

  useEffect(() => {
    if (!currentSound.current) {
      return;
    }
    currentSound.current.volume(getVolume(currentVolume));
  }, [currentVolume]);

  useEffect(() => {
    return function () {
      if (!currentSound.current) {
        return;
      }
      currentSound.current.stop();
    };
  }, []);

  return null;
}

function GlobalClick({ url, volume = 0.5 }) {
  const { volume: currentVolume, sounds } = useGameSettings();
  const [playSound, { sound }] = useSound(url, { volume });

  useEffect(() => {
    if (!sound) {
      return;
    }
    sound.volume(getVolume(currentVolume));
  }, [currentVolume]);

  useEffect(() => {
    if (sounds) {
      window.addEventListener("mousedown", playSound);
    } else {
      window.removeEventListener("mousedown", playSound);
    }
  }, [sounds]);

  useEffect(() => {
    return function () {
      window.removeEventListener("mousedown", playSound);
    };
  }, []);

  return null;
}

export default {
  Music,
  GlobalClick,
};
